<template>
  <div class="w-full h-screen bg-primary flex justify-center items-center">
    <div class="animate-spin rounded-full h-24 w-24 border-b-4 border-white"></div>
  </div>
</template>

<script>
export default {
}
</script>

<style>
</style>